import { Body, Head, Html, Img, Link, Text } from "@react-email/components";
import { Email as Styles } from "themes/styles";
import { Helpers } from "utils";

// components
import { Footer } from "./components";

export type Props = {
  url: string;
  name: string;
};

export const ForgotPassword = ({ url, name }: Props) => {
  return (
    <Html lang="en">
      <Head />
      <Body style={Styles.body}>
        <Img
          style={Styles.img}
          src={Helpers.getImage("email_forgot_password.png")}
        />
        <div style={Styles.content}>
          {/* header */}
          <Text style={Styles.textBold}>Hello {name},</Text>

          {/* paragraph */}
          <Text style={Styles.textBold}>
            Click the following button to reset your password.
          </Text>

          {/* button */}
          <Link href={url} style={Styles.button}>
            Reset My Password
          </Link>
        </div>
        <Footer />
      </Body>
    </Html>
  );
};
